import React from 'react';
import classNames from 'classnames/bind';
import { Device } from '@beef/smart-kit';
import { useDispatch, useSelector } from 'react-redux';

import { redirectToBasket } from 'utils/basket';
import { deviceButtonTitle, deviceVariant } from 'constants/device';
import commonStyles from 'styles/common.pcss';
import { getIsItemInBasket } from 'store/common/basket/selectors';
import {
  addToBasketCrossSell,
} from 'store/ProductDetails/crossSellProducts/actions';
import { SOURCES } from 'store/common/basket/constants';

import styles from '../styles.pcss';
const cx = classNames.bind({ ...commonStyles, ...styles });

interface IProduct {
  article: string | null,
  badges: IBadge[],
  brand: string,
  buttonHref: string | null,
  buttonText: string | null,
  category: string,
  categoryId: number,
  contentPromotionTitle: string | null,
  enriched: boolean,
  headline: string | null,
  subHeadline: string | null,
  imageUrl: string,
  isPreorder: boolean,
  price: {
    oldValue: number | null,
    value: number
  },
  discount: string | null,
  productId: string,
  rate: number,
  feedbackCount: number,
  remain: number,
  remainOp: number | null,
  isSoonOnSale: boolean,
  slug: string,
  title: string,
  url: string,
  date: string | null,
  description: string | null,
  timer: string | null,
  label: string | null
  feedback: {
    count: number;
    average: number;
  }
}

interface IBadge {
  title: string,
  content: string,
  variant: string,
  textColor: string,
}


const getDeviceData = (product: IProduct) => {
  // eslint-disable-next-line consistent-return
  const getDiscount = (price: number, oldPrice: number | null) => {
    if (oldPrice) {
      return Math.floor((((oldPrice - price) * 100) / oldPrice));
    }
  };

  // eslint-disable-next-line consistent-return
  const getBadges = (badges: IBadge[]) => {
    if (badges) {
      return badges.map((badge) => ({
        children: badge.title,
        help: badge.content,
        variant: badge.variant,
        textColor: badge.textColor,
      }));
    }
  };

  const isSamePrice = product?.price?.value === product?.price?.oldValue;
  const discount = getDiscount(product?.price?.value, product?.price?.oldValue);

  return {
    reviews: {
      count: product?.feedback?.count,
      average: product?.feedback?.average,
      link: `shop/details/${product?.slug}/otzyvy/`,
    },
    promoBadges: getBadges(product?.badges),
    slug: product?.url,
    id: product?.productId,
    imgOptions: {
      src: product?.imageUrl,
    },
    name: product?.title,
    price: product?.price?.value,
    oldPrice: !isSamePrice && product?.price?.oldValue,
    discount: !isSamePrice && discount,
    link: `/shop/details/${product?.slug}`,
  };
};

interface Props {
  product: IProduct,
  isMobile: boolean,
}

export const DeviceBlock: React.FC<Props> = ({ product, isMobile }) => {
  const dispatch = useDispatch();
  const isItemInBasket = useSelector((state) => getIsItemInBasket(state, product?.productId?.toString()));

  const purchaseDataTitle = isItemInBasket ? deviceButtonTitle.IN_BASKET : deviceButtonTitle.TO_BASKET;
  const variant = isItemInBasket ? deviceVariant.SECONDARY : deviceVariant.TERTIARY;

  const purchaseData = {
    variant,
    title: purchaseDataTitle,
    onClick: () => {
      if (isItemInBasket) {
        redirectToBasket();
      } else {
        dispatch(addToBasketCrossSell(product, SOURCES.SOURCE_NEW_BASKET_RECOMMENDED_PRODUCT, true));
      }
    },
  };

  return (
    <Device
      className={cx('deviceItem', isMobile && 'mobile')}
      onOpenModal={() => { window.location.href = product?.url; }}
      purchaseData={purchaseData}
      device={getDeviceData(product)}
      isWithModal
    />
  );
};
